import { SVGProps } from 'react';

const ClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v6l3.644 1.822M16 19h6m-3-3v6m2.92-8.733a10 10 0 1 0-8.653 8.653"
    />
  </svg>
);
export default ClockPlus;
